import {GET_PATIENTS_REQUEST, GET_PATIENTS_SUCCESS, GET_PATIENTS_FAILURE,
        ADD_PATIENT_REQUEST, ADD_PATIENT_SUCCESS, ADD_PATIENT_FAILURE,
        DELETE_PATIENT_REQUEST, DELETE_PATIENT_SUCCESS, DELETE_PATIENT_FAILURE
} from './constants';

export function getPatients(page, filterOptions, sortingOptions) {
    return {
        type: GET_PATIENTS_REQUEST,
        data: { page, filterOptions, sortingOptions }
    }
}

export function getPatientsSuccess(response) {
    return {
        type: GET_PATIENTS_SUCCESS,
        data: response
    }
}

export function getPatientsFailure() {
    return {
        type: GET_PATIENTS_FAILURE,
        data: {}
    }
}

export function addPatient(data) {
    return {
        type: ADD_PATIENT_REQUEST,
        data
    }
}

export function addPatientSuccess(response) {
    return {
        type: ADD_PATIENT_SUCCESS,
        data: response
    }
}

export function addPatientFailure() {
    return {
        type: ADD_PATIENT_FAILURE,
        data: {}
    }
}

export function deletePatient(patientId, page, filterOptions, sortingOptions) {
    return {
        type: DELETE_PATIENT_REQUEST,
        data: { patientId, page, filterOptions, sortingOptions }
    }
}

export function deletePatientSuccess(response) {
    return {
        type: DELETE_PATIENT_SUCCESS,
        data: response
    }
}

export function deletePatientFailure() {
    return {
        type: DELETE_PATIENT_FAILURE,
        data: {}
    }
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Patients/actions.js